<template>
  <div class="tool_bar">
    <div
      class="depart_operate add_depart"
      v-if="show_add_sub_depart && departItem.level < 8"
      @click="add"
    >
      <i class="el-icon-circle-plus"></i>
      {{ only_show_icon ? '' : $t('add_childe_depart') }}
    </div>
    <div v-if="!!departId" class="depart_operate edit_depart" @click="change">
      <i class="el-icon-edit"></i>
      {{ only_show_icon ? '' : $t('modify') }}
    </div>
    <div v-if="!!departId" class="depart_operate delete_depart" @click="delate">
      <i class="el-icon-error"></i>
      {{ only_show_icon ? '' : $t('delete') }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ToolBar',
    props: {
      departId: {
        type: Number
      },
      departItem: {
        type: Object,
        require: false
      }
    },
    inject: {
      provideData: {
        value: 'provideData',
        default: {
          showAddSubDepart: true,
          onlyShowIcon: false
        }
      }
    },
    computed: {
      show_add_sub_depart() {
        const show = this.provideData.showAddSubDepart
        return show === undefined ? true : !!show
      },
      only_show_icon() {
        return this.provideData.onlyShowIcon
      }
    },
    methods: {
      add() {
        this.$emit('addItem', this.departId, this.departItem)
      },
      change() {
        let parentItem = {
          id: this.$parent.$parent.id,
          name: this.$parent.$parent.title
        }
        this.$emit('editItem', this.$parent.id, parentItem, this.departItem)
      },
      delate() {
        this.$emit('deleteItem', this.departId)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tool_bar {
    display: inline-block;
    margin-left: 10px;
    .depart_operate {
      width: auto;
      height: 30px;
      line-height: 30px;
      padding-left: 8px;
      color: var(--gray-5f);
      margin-top: -1px;
      vertical-align: middle;
      display: inline-block;
      cursor: pointer;
      user-select: none;
      i {
        font-size: 14px;
      }
      &.add_depart {
        cursor: pointer;
        color: var(--success);
      }
      &.edit_depart {
        cursor: pointer;
        color: var(--blue);
      }
      &.delete_depart {
        cursor: pointer;
        color: var(--warning);
      }
    }
  }
</style>
